import { ParametrosWSBase, DestinoConexion } from "../ParametrosWSBase";
import { EncabezadoRespuestaInterna } from "../EncabezadoRespuestaInterna";

export function _reenviarOTT(datos: any) {
  var par: ParametrosWSBase = {
    nombreProceso: "RenviarOTT",
    rutaEndPoint: "/izzi/token/reenviar",
    sistemaOrigen: "SEL",
    AGREGAR_ENCABEZADO: true,
    DESTINO_SERVICIO: DestinoConexion.Proxy,
    parametros: { ...datos },
    cRC: null,
  };

  return par;
}

//ENTRADA

export interface reenviarOTT_Entrada {
  numberContract: string;
  zipCode: string;
  complement: ComplementReenviar[];
}

export interface ComplementReenviar {
  nombreComercial: string;
  nombreSiebel: string;
}

export function builtReenviarOTTEntrada(
  l_numberContract: string,
  l_zipCode: string,
  l_complement: ComplementReenviar[]
) {
  var retorno: reenviarOTT_Entrada = {
    numberContract: l_numberContract,
    zipCode: l_zipCode,
    complement: l_complement,
  };

  return retorno;
}

//SALIDA

export interface reenviarOTT_Salida {
  code: string;
  message: string;
  datos: datos;
}

export interface datos {
  account_number: string;
  zip_code: string;
  email: string;
  phone_number: string;
}

export type reenviarOTT_Respuesta = EncabezadoRespuestaInterna &
  reenviarOTT_Salida;
